export default __webpack_public_path__ + "static/media/occupation.480da9da.png";